import { HStack } from '@chakra-ui/react';
import { NavLink } from 'react-router-dom';

import {
  Avatar,
  Button,
  Show,
  MenuContent,
  MenuItem,
  MenuRoot,
  MenuTrigger,
  Typography,
} from 'shared';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';

import { getParticipantUrl } from 'features/participants/utils';

type Participant = {
  userName: string;
  userEmail: string;
  userId: string;
  pictureUrl: string;
};

type ParticipantsMenuProps = {
  participants: Participant[];
  isActive: boolean;
};

export const HeaderTabsParticipantsMenu = ({
  participants,
  isActive,
}: ParticipantsMenuProps) => {
  return (
    <MenuRoot placement="bottom-end" offset={[0, 5]}>
      <MenuTrigger
        as={Button}
        size="xs"
        variant={isActive ? 'solid' : 'outline'}
      >
        <Typography color={isActive ? 'white' : 'black'} fontSize="small">
          Participants
        </Typography>{' '}
        <Icon
          name={iconNames.chevronDown}
          stroke={isActive ? 'var(--fgPrimaryInverse)' : 'var(--fgPrimary)'}
        />
      </MenuTrigger>
      <MenuContent p={0} maxH="95vh" overflowY="auto">
        <ParticipantMenuItem to="/coach/participants" text="All participants" />
        {participants
          .sort((p1, p2) => p1.userName.localeCompare(p2.userName))
          .map(({ userName, userId, userEmail, pictureUrl }) => (
            <ParticipantMenuItem
              key={userId}
              to={getParticipantUrl(userEmail)}
              text={userName}
              pictureUrl={pictureUrl}
            />
          ))}
      </MenuContent>
    </MenuRoot>
  );
};

const ParticipantMenuItem = ({
  to,
  text,
  pictureUrl,
}: {
  to: string;
  text: string;
  pictureUrl?: string;
}) => (
  <MenuItem p={0}>
    <NavLink to={to} style={{ width: '100%', height: '100%' }}>
      <HStack w="full" h="full" px="12px" alignItems="center">
        <Show when={pictureUrl}>
          <Avatar name={text} size="2xs" src={pictureUrl} />
        </Show>
        <Typography type="small" color="black">
          {text}
        </Typography>
      </HStack>
    </NavLink>
  </MenuItem>
);
